import React from "react";

const AddMoreFields = (props) => {
  const { label, register, name } = props;

  return (
    <div
      className={`checkout-form__field checkout-form___field--add-more checkout-form__${name}`}
    >
      <label>
        <input
          aria-label={label || "plus-button"}
          type="checkbox"
          {...register(name)}
        />
        <span>{label}</span>
      </label>
    </div>
  );
};

export default AddMoreFields;
